module.exports = __webpack_public_path__ + "static/media/Arctic_Fauna_App_Recording.56c7ca4e.mp4";